export const VUE_APP_BUILD_ENV = process.env.VUE_APP_BUILD_ENV

export const API_BASE_URL = VUE_APP_BUILD_ENV === 'test' ? '//asset-shop.jdtest.net' : '//asset-api.shop.jd.com'

export const FW_HOST_URL = VUE_APP_BUILD_ENV === 'test' ? 'fw.jdtest.net' : 'fw.jd.com'

export const E_CUSTOM_ITEM_ID = 24
